export default {
  props: {
    data: {
      type: Array,
      required: true
    },
    /**
     * Allows supporting non-reactive data, and prevents recreating the
     * DataTable component every time the data array prop is updated.
     * Watching this prop presents changes in the data array,
     * and the need to update data passed to AgGridVue
     */
    dataUpdated: {
      type: Number,
      required: true
    }
  },
  watch: {
    dataUpdated: {
      async handler (rowCount) {
        if (!this.gridOptions.api) return

        if (!rowCount) await nextTick()

        this.gridOptions.api.setGridOption('rowData', this.data)
        this.gridOptions.api.setFilterModel(this.tableFilterable.filters)
      },
      immediate: true
    },
    gridOptions: {
      deep: true,
      handler () {
        if (!this.gridOptions.api) return

        this.gridOptions.api.setGridOption('rowData', this.data)
        this.gridOptions.api.setFilterModel(this.tableFilterable.filters)
      }
    }
  }
}
